<template>
  <div class="m-5">
    <router-view />
  </div>
</template>

<script>
export default {};
</script>
